<template>
  <container-sc>
    <div class="header">
      <img src="/textures/page/icon/back_black.svg" @click="onBackClick"/>
      <span>{{$t('share.shareSetting')}}</span>
    </div>
    <div class="content">
      <div v-if="isShowTitleSetting" class="title-setting">
        <span class="title-label">{{t('miniprogramCode.wxacodeTitle')}}</span>
        <input
          ref="titleRef"
          type="text"
          v-model.trim="wxacodeTitle"
          :placeholder="t('miniprogramCode.planTitle')"
          @focus="isPlanTitleFocused = true"
          @blur="isPlanTitleFocused = false"
          @input="dealWXACodeTitle"
        />
        <span v-show="isPlanTitleFocused" class="text-length">{{wxacodeTitle.length}}/20</span>
        <div v-show="wxacodeTitle" class="clear-title" @click="handleTitleClear">
          <img src="/textures/page/icon/small_clear.svg" />
        </div>
      </div>
      <div v-if="isShowStyleList" class="share-style">
        <card-title-sc>
          <span>{{$t('share.selectShareStyle')}}</span>
          <div v-show="styleListOption.length > 3" class="fold-button" @click="handleFoldClick">
            <span>{{foldButtonText}}</span>
            <img :class="{unfolded: isUnfolded}" src="/textures/page/icon/caret_down.svg" />
          </div>
        </card-title-sc>
        <div class="style-list">
          <div :class="['style-item', {active: style.isSelected}]" v-for="style in panoList" :key="style.id">
            <div class="main" @click="handleStyleClick(style)">
              <img class="main-img" :src="style.imagePath"/>
              <img
                class="main-title"
                src="/textures/page/icon/selected_24.svg"
                v-show="style.isSelected"
              />
              <div v-if="style.isSelected && quotedPriceMap[style.id]" class="quoted-price" @click.stop="onQuotedPriceClick(style.id)">
                <span>{{t('share.quotedPriceSetting')}}</span>
                <img src="/textures/page/icon/angle_right.svg" />
              </div>
              <img v-show="style.isSelected && quotedIDMap[style.id]" class="quoted-img" src="/textures/page/icon/quoted.svg" />
            </div>
            <span>{{style.photoAlbumName || getViewName(style.name)}}</span>
          </div>
        </div>
      </div>
      <div class="share-aging">
        <card-title-sc>{{$t("share.setLinkAging")}}</card-title-sc>
        <div class="list">
          <div
            v-for="item in agingListOption"
            :key="item.id"
            :class="['list-item', {'selected-item': item.isSelected}]"
            @click="switchShareItem(item)"
          >
            <div class="left">
              <div class="top">
                <img :src="renderImgUrl(item.icon)" />
                <div class="list-title">{{item.title}}
                  <span class="sub-title">{{item.date||item.subTitle}}</span>
                </div>
              </div>
              <div class="btm">
              </div>
            </div>
            <div v-if="item.isSelected" :class="['right', {'viewing-time': item.type === 'viewingTime'}]">
              <div v-if="item.type === 'viewingTime'" class="viewing-time-box" @click.stop="showViewingTimeSetting">
                <span>{{t('share.viewingTime')}}{{getRenderValue(viewingTime.day, viewingTime.hour)}}</span>
                <img src="/textures/page/icon/arrow-right-arrow-left.svg" />
              </div>
              <img v-else src="/textures/page/icon/selected.svg" />
            </div>
          </div>
        </div>
        <div class="bottom-tip">{{$t("share.expireTime")}}:&nbsp;{{expireTime}}</div>
      </div>
      <div class="share-person" @click="showSelectPerson">
        <img class="avatar" v-if="selectedPerson.wxAvatarUrl" :src="selectedPerson.wxAvatarUrl"/>
        <img class="avatar" v-else src="/textures/page/default_avatar.png"/>
        <span v-if="selectedPerson.staffName">{{$t('share.sharePerson') + selectedPerson.staffName}}</span>
        <span v-else>{{$t('share.selectSharePerson')}}<span class="tip">{{ t('share.notRequired') }}</span></span>
        <img src="/textures/page/icon/enter_black.svg"/>
      </div>
    </div>
    <div v-show="!isShow2ConfirmBtn" class="bottom">
      <button
        class="bottom-btn active"
        @click="handleConfirmClick(false)"
      >{{ confirmButtonText || $t("share.confirmShare") }}</button>
    </div>
    <div v-show="isShow2ConfirmBtn" class="bottom2">
      <div :class="['share', { single: !isMarketingsCustomerInfoXCXCharged }]" @click="handleConfirmClick(false)">
        <span class="main-text">{{ $t('share.shareWechatCard') }}</span>
        <span class="sub-text">{{ $t('share.basicShareMode') }}</span>
      </div>
      <div v-if="isMarketingsCustomerInfoXCXCharged" class="share active" @click="handleConfirmClick(true)">
        <span class="main-text">{{ $t('share.shareMiniprogram') }}</span>
        <span class="sub-text">{{ $t('share.getEfficiently') }}</span>
      </div>
    </div>
    <div class="background" v-show="isShowTimePicker" @click="handleDatePickerExit"></div>
    <bottom-dialog
      :visible="isShowTimePicker"
      :is-show-down="true"
      :header-close-style="{display: 'none'}"
      :dialog-style="{backgroundColor: 'white', zIndex : 3, right: 0, position: 'fixed'}"
      :header-style="headerStyle"
      :content-style="{backgroundColor: '#ffffff', padding: 0}"
    >
      <date-picker
        v-model="selectedDate"
        :min-date="new Date()"
        @handleClickFinish="handleFinishClick"
      >
      </date-picker>
    </bottom-dialog>
    <teleport to="body" v-if="isShowSelectPerson">
      <select-person
        :list="shareList"
        :no-record-title="$t('share.noSharePerson')"
        :no-record-sub-title="$t('share.createShareListTip')"
        :on-back-click="closeSelectPerson"
        :on-item-canceled="handlePersonCanceled"
        :on-item-selected="handlePersonSelected"
        :placeholder="$t('share.searchName')"
        :selected-item="selectedPerson"
        :title="$t('share.selectSharePerson')"
      />
    </teleport>
    <bottom-dialog
      v-if="isShowSetTime"
      :visible="isShowSetTime"
      :dialog-title="t('share.setViewingTime')"
      :on-close-dialog="closeViewingTimeSetting"
      :header-close-style="{display: 'none'}"
      overlay
      :dialog-style="settingTimeDialogStyle"
      :header-style="{padding: '18px 24px 6px'}"
      :title-style="settingTimeTitleStyle"
      :content-style="{padding: '0 24px'}"
    >
      <async-set-time :selected="viewingTime" @confirm="handleSetTimeConfirm" />
    </bottom-dialog>
    <!-- 报价弹框 -->
    <bottom-dialog
      :visible="isShowQuotedPrice"
      :dialog-title="t('share.selectQuotedPrice')"
      :on-close-dialog="onCloseQuotedPrice"
      :is-show-down="false"
      is-show-fold
      overlay
      :dialog-style="quotedDialogStyle"
      :header-style="{padding: '6px 16px'}"
      :header-close-style="{fontSize: 0}"
      :title-and-close-style="{position: 'relative', justifyContent: 'flex-end'}"
      :title-style="quotedTitleStyle"
    >
      <div class="quoted-price-container">
        <div class="quoted-list">
          <div v-for="item in quotedPriceOptionList" :key="item.id" class="quoted-item" @click="onClickQuotedOption(item.id)">
            <div class="name">{{item.name}}</div>
            <div class="price">
              <span>￥{{item.totalPrice}}</span>
              <div class="radio">
                <img v-show="item.id === quotedDialogSelectedID" src="/textures/page/icon/circle_dot.svg" />
                <img v-show="item.id !== quotedDialogSelectedID" src="/textures/page/icon/circle.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="confirm" @click="onQuotedDialogConfirm">{{t('liveDeco.sure')}}</div>
      </div>
    </bottom-dialog>
  </container-sc>
</template>

<script setup>
import {ContainerSc, CardTitleSc} from './shareSettingSc';
import {getViewName} from '../../../methods/diy2d';
import BottomDialog from '../../common/dialogs/bottom-dialog/index.vue';
import DatePicker from '../copy-link/date-picker/DatePicker.vue';
import {useMessage} from '../../common/message-tip';
import {computed, ref, onMounted, reactive, inject, defineAsyncComponent} from 'vue';
import {useI18n} from 'vue-i18n';
import SelectPerson from '../../select-person/SelectPerson.vue';
import {useStore} from 'vuex';
import {House} from '../../../common/constant';
import {Charged_Feature_Array, Feature_Key} from '../../../modules/userFeature.js';

const AsyncSetTime = defineAsyncComponent(() => import('./set-time/SetTime.vue'));

const VITE_BASE = import.meta.env.VITE_BASE;

const props = defineProps({
  agingList: Array,
  onBackClick: Function,
  onConfirmClick: Function,
  showDate: Function,
  styleList: {
    type: Array,
    default: () => []
  },
  visible: {
    type: Boolean,
    default: false
  },
  // 是否显示标题设置项
  isShowTitleSetting: {type: Boolean, default: false},
  // 是否显示选择分享风格
  isShowStyleList: { type: Boolean, default: true },
  // 确认按钮文本
  confirmButtonText: { type: String, default: '' },
  // 小程序码默认标题
  defaultTitle: { type: String, default: House.HouseInfo.HouseName.slice(0, 20) },
  // 是否显示两个确认按钮
  isShow2ConfirmBtn: { type: Boolean, default: false },
});

const messageTip = useMessage();
const {t} = useI18n();
const store = useStore();
const chargedFeatureArray = inject(Charged_Feature_Array);
const userInfo = inject('userInfo');

const styleListOption = ref([]);
const selectedStyles = computed(() => styleListOption.value.filter(style => style.isSelected));

const agingListOption = ref([]);
const isShowTimePicker = ref(false);
const selectedDate = ref(new Date(new Date().getTime() + 12 * 60 * 60 * 1000));
const expireTime = computed(() => props.showDate(selectedDate.value));

const headerStyle = {
  backgroundColor: 'white',
  padding: '0px 0 0 0px',
  borderRadius: '25px 25px 0 0',
  boxShadow: '0 2px 8px 0 rgb(0,0,0,0.5)',
  marginTop: '16px'
};

const renderImgUrl = (icon) => {
  return `${VITE_BASE}textures/page/icon/${icon}`;
};

/** 报价最终选中结果 */
const quotedIDMap = ref({});
/**
 * 处理风格点击逻辑
 * @param {{}} style 风格对象
 */
const handleStyleClick = (style) => {
  style.isSelected = !style.isSelected;
  quotedIDMap.value[style.id] = undefined;
};
const setModelMinutes = (val) => {
  return new Date(new Date(val).setMinutes(new Date().getMinutes()));
};

//---- 小程序码标题设置 ----//
const wxacodeTitle = ref(props.defaultTitle || '');
const isPlanTitleFocused = ref(false);
const titleRef = ref();
const dealWXACodeTitle = () => {
  if (wxacodeTitle.value.length > 20) {
    wxacodeTitle.value = wxacodeTitle.value.slice(0, 20);
  }
};
const handleTitleClear = () => {
  titleRef.value.focus();
  wxacodeTitle.value = '';
};

const isMarketingsCustomerInfoXCXCharged = computed(() => chargedFeatureArray.value.includes(Feature_Key.marketingsCustomerInfoXCX));
/** 处理分享按钮点击逻辑 */
const handleConfirmClick = (isShareMiniprogram) => {
  // 分享风格
  if (props.isShowStyleList && selectedStyles.value.length === 0) {
    messageTip.show(t('share.styleSelectTip'));
    return;
  }
  const selectedTaskIDs = [];
  selectedStyles.value.forEach(style => selectedTaskIDs.push(style.id));

  // 链接有效期
  selectedDate.value = setModelMinutes(selectedDate.value);
  const selected = {
    selectedTaskIDs,
    selectedDate: selectedDate.value,
    isShareMiniprogram,
  };

  // 分享人
  if (selectedPerson.id) {
    selected.shareStaffId = selectedPerson.id;
  }

  // 观看时长，单位：分钟
  if (viewingTime.value.day !== 99) {
    selected.viewLimit = viewingTime.value.day * 24 * 60 + viewingTime.value.hour * 60;
  }

  // 小程序码标题
  if (props.isShowTitleSetting && wxacodeTitle.value.length > 0) {
    selected.wxacodeTitle = wxacodeTitle.value;
  }

  // 报价
  const quotedPrice = {};
  for (let key in quotedIDMap.value) {
    if (quotedIDMap.value[key]) {
      quotedPrice[key] = quotedIDMap.value[key];
    }
  }
  if (Object.keys(quotedPrice).length !== 0) {
    selected.quotedPrice = quotedPrice;
  }
  props.onConfirmClick && props.onConfirmClick(selected);
};
/** 处理时间选择弹窗退出逻辑 */
const handleDatePickerExit = () => {
  isShowTimePicker.value = false;
};
/** 处理时间选择器完成按钮点击逻辑 */
const handleFinishClick = () => {
  handleDatePickerExit();
  selectedDate.value = setModelMinutes(selectedDate.value);
};
/** 设置自定义时效 */
const setAging = (item) => {
  selectedDate.value = item.val;
  if (item.type === 'datepicker') {
    selectedDate.value = setModelMinutes(selectedDate.value);
  }
};
/** 切换时效选项 */
const switchShareItem = (option) => {
  // 除自定义到期日选项外，重复点击不做处理
  if (option.type !== 'datepicker' && option.isSelected) {
    return;
  }
  agingListOption.value.forEach((item) => {
    if (item.id === option.id) {
      item.isSelected = true;
      if (item.type === 'datepicker') {
        isShowTimePicker.value = true;
      }
      setAging(item);
    } else {
      item.isSelected = false;
    }
  });
  viewingTime.value = defaultViewingTime;
};
//---- 观看时长逻辑 ----//
const defaultViewingTime = {type: 'predefined', day: 99, hour: 0};
const viewingTime = ref(defaultViewingTime);
const isShowSetTime = ref(false);
const settingTimeDialogStyle = {
  height: '318px',
  background: '#FFFFFF',
  boxShadow: '0px 2px 8px 0px rgb(0 0 0 / 15%)',
  borderRadius: '24px 24px 0px 0px',
};
const settingTimeTitleStyle = {
  fontSize: '16px',
  fontFamily: 'PingFangSC-Medium, PingFang SC',
  color: '#333333',
  lineHeight: '22px',
};
// 打开设置观看时长弹窗
const showViewingTimeSetting = () => {
  isShowSetTime.value = true;
};
// 关闭设置观看时长弹窗
const closeViewingTimeSetting = () => {
  isShowSetTime.value = false;
};
// 获取时间显示值
const getRenderValue = (day, hour) => {
  if (day === 99) {
    return t('share.forever');
  }
  if (day === 0) {
    return `${hour}${t('share.hourUnit')}`;
  }
  if (hour === 0) {
    return `${day}${t('share.day')}`;
  }
  return `${Math.round(hour * 10 / 24) / 10 + day}${t('share.day')}`;
};
// 确认设置观看时长
const handleSetTimeConfirm = (current) => {
  viewingTime.value = current;
  closeViewingTimeSetting();
};

const selectedPerson = reactive({});
// 分享人列表
const shareList = ref([]);
const isShowSelectPerson = ref(false);
// 获取分享人列表
const getShareList = async () => {
  if (store.state.companyAccountId <= 0) {
    return;
  }
  const {state, payload} = await HouseViewer.DIY2DInterface.getStaffList(store.state.companyAccountId);
  if (state !== 200) {
    return [];
  }
  return payload;
};
const closeSelectPerson = () => {
  isShowSelectPerson.value = false;
};
const showSelectPerson = () => {
  if (!chargedFeatureArray.value.includes(Feature_Key.marketingsCustomerInfoXCX)) {
    messageTip.show(t('share.sharePersonFeatureTip'));
    return;
  }
  isShowSelectPerson.value = true;
};
const handlePersonSelected = (person) => {
  closeSelectPerson();
  Object.assign(selectedPerson, person);
};
const handlePersonCanceled = () => {
  for (let key in selectedPerson) {
    selectedPerson[key] = undefined;
  }
};

// 是否展开状态
const isUnfolded = ref(false);
const foldButtonText = computed(() => {
  return isUnfolded.value ? t('share.fold') : t('share.unfold');
});
const panoList = computed(() => {
  return isUnfolded.value ? styleListOption.value : styleListOption.value.slice(0, 3);
});
const handleFoldClick = () => {
  isUnfolded.value = !isUnfolded.value;
};

//---- 报价设置 ----//
/** { taskID: 报价列表 } */
const quotedPriceMap = ref({});
/** 获取渲染效果对应的报价列表 */
const getQuotedList = async () => {
  const { state, payload } = await HouseViewer.DIY2DInterface.getQuotedList({
    propertyId: store.state.activePackageId,
    userId: userInfo.value.owner?.id,
  });
  if (state !== 200) {
    return;
  }
  payload.forEach((quotedPrice) => {
    if (quotedPrice.isDelete) {
      return;
    }
    const propertyStyle = JSON.parse(quotedPrice.propertyStyle);
    const taskQuotedPrices = quotedPriceMap.value[propertyStyle.id];
    if (taskQuotedPrices) {
      taskQuotedPrices.push(quotedPrice);
      return;
    }
    quotedPriceMap.value[propertyStyle.id] = [quotedPrice];
  });
};
/** 需要分享的报价选项列表 */
const quotedPriceOptionList = ref([]);
/** 是否显示选择报价弹框 */
const isShowQuotedPrice = ref(false);
/** 报价弹框选中值 */
const quotedDialogSelectedID = ref();
/** 当前渲染效果ID */
const currentTaskID = ref();
/**
 * 点击报价设置
 * @param {string} taskID 渲染效果ID
 */
const onQuotedPriceClick = (taskID) => {
  currentTaskID.value = taskID;
  quotedPriceOptionList.value = quotedPriceMap.value[taskID];
  const selectedID = quotedIDMap.value[taskID];
  if (selectedID) {
    quotedDialogSelectedID.value = selectedID;
  } else {
    quotedDialogSelectedID.value = undefined;
  }
  isShowQuotedPrice.value = true;
};
/** 关闭分享报价弹窗 */
const onCloseQuotedPrice = () => {
  isShowQuotedPrice.value = false;
};
/** 点击报价列表选项 */
const onClickQuotedOption = (quotedPriceID) => {
  if (quotedDialogSelectedID.value === quotedPriceID) {
    quotedDialogSelectedID.value = undefined;
    return;
  }
  quotedDialogSelectedID.value = quotedPriceID;
};
/** 点击报价弹窗确认 */
const onQuotedDialogConfirm = () => {
  quotedIDMap.value[currentTaskID.value] = quotedDialogSelectedID.value;
  onCloseQuotedPrice();
};
/** 报价弹框样式 */
const quotedDialogStyle = {
  height: '348px',
  background: '#FFFFFF',
  boxShadow: '0px 2px 8px 0px rgb(0 0 0 / 15%)',
  borderRadius: '24px 24px 0px 0px',
};
const quotedTitleStyle = {
  fontSize: '16px',
  fontFamily: 'PingFangSC-Medium, PingFang SC',
  color: '#333333',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
};

const init = async () => {
  props.styleList?.forEach(style => {
    const isSelected = style.id === store.state.style2DDiy.id;
    styleListOption.value.push({...style, isSelected});
  });

  props.agingList.forEach((aging) => {
    agingListOption.value.push(aging);
    if (aging.isSelected) {
      setAging(aging);
    }
  });

  shareList.value = await getShareList();

  if (!store.state.isPanoramaMode && props.isShowStyleList) {
    getQuotedList();
  }
};
onMounted(init);
</script>
